import { createFileRoute } from '@tanstack/react-router'
import { ContractEditor } from '~/features/compensation/ContractEditor'
import { NoFinanceAccess } from '~/features/compensation/parts'
import { contractQuery, loaderSeason, typesQuery } from '~/features/compensation/queries'
import { useCan } from '~/lib/session'

export const Route = createFileRoute('/_app/verein/praemien/vertraege/$contractId')({
  loader: async ({ context, params }) => {
    const s = await loaderSeason(context.queryClient)
    if (!s?.canRead) return
    await Promise.all([
      context.queryClient.ensureQueryData(contractQuery(params.contractId)).catch(() => undefined),
      context.queryClient.ensureQueryData(typesQuery()),
    ])
  },
  component: function Vertrag() {
    const { contractId } = Route.useParams()
    return useCan()('finance.read') ? <ContractEditor contractId={contractId} /> : <NoFinanceAccess title="Verträge" />
  },
})
